import React from 'react';

const Footer = () => {
    return (
        <footer className='mt-auto bg-[#0A192F] text-white p-6 text-center'>
            <p className='text-sm lg:text-base text-gray-400'>
                © 2026 Jesús Troconiz · Built for speed & clarity
            </p>
        </footer>
    );
}

export default Footer;
